<template>
  <div :class="darkMode ? 'dark' : ''">
    
    <!-- Messaggio che appare se si accede da mobile e schermi md -->
    <div id="onlydesktop" class="block md:!hidden"> 
			<div v-if="loggedAs && loggedAs.ruolo=='admin'" id="onlydesktopAdmin" class=" bg-csenRed-200 p-12">
				<div class="bg-csenRed-100 text-csenRed-600 p-3 inline-flex rounded-full mb-4">
					<MobileIcon></MobileIcon>
				</div>
				<div class="bg-csenGreen-100 text-csenGreen-600 p-3 inline-flex rounded-full mb-4">
					<DesktopIcon></DesktopIcon>
				</div>
				<div><h2 class="text-left text-lg text-csenRed-800 font-bold mb-2">⛔ Accesso non consentito</h2></div>
				<p class=" text-left text-csenRed-900 text-base font-semibold">L'accesso come amministratore <strong>non è consentito da mobile</strong>. Collegati da un computer desktop per svolgere le attività come amministratore.</p> 

			</div>
		</div>

    <div id="maincontainer" class="hidden md:!block sm:px-[5%] !font-sans bg-white dark:bg-[#171a35]">
         <div class="bg-csenBlue-950 dark:bg-csenBlue-900 px-12 sm:px-24 py-12 rounded-b-md">
           <!-- MENU TECNICI -->
           <MenuTecnici @avvia-guida="avviaTour"></MenuTecnici>
           <!-- INIZIO RICERCA -->
           <div flat class="mt-6 bg-white px-6 py-3 rounded-md">
             <v-text-field
               v-model="search"
               hide-details
               flat
               solo
               light
               class="relative w-full border-none rounded-lg dark:text-white "
               prepend-icon="mdi-magnify"
               clearable
               placeholder="Cerca tra le circolari inviate"
               clear-icon="mdi-close-circle-outline"
               @click:clear="resetSearch()"
             ></v-text-field>
           </div>
           <!-- FINE RICERCA -->
         </div>
   
         <div class="flex justify-end mr-1 mt-2">
          <div class="xl:w-1/4">
            <div class="flex">
              <HistoryIcon class="my-auto w-10 h-10 mr-2 pt-3 text-csenBlue-400"></HistoryIcon>
            <v-select
                v-model="is_storico_richiesto"
                :items="[{title: 'Recenti (meno di 15 giorni)', value: false}, {title: 'Storico (oltre 15 giorni)', value: true}]"
                item-text="title"
                item-value="value"
                label="Visualizza email recenti / storico"
                outlined
                class="my-auto mt-4"
                hide-details
            >
            </v-select>
 
          </div>
          </div>
        </div>
  
         <div class="grid mt-4 mb-6 gap-2 grid-cols-3 items-stretch">
  
            <!-- Login dei tecnici -->
            <div @click="openRiepilogoInviiDialog(circolariInviateTransazionali['login_tecnico'])" class="flex flex-col bg-csenBlue-50 group hover:bg-csenBlue-200 dark:bg-csenBlue-800 hover:dark:bg-csenBlue-700 rounded-md p-4 2xl:p-6 cursor-pointer transition h-full">
              <div class="flex justify-between content-evenly flex-grow">
                <div class="my-auto justify-start font-medium text-sm 2xl:text-base text-csenBlue-950 dark:text-csenBlue-200">Login dei Tecnici</div>
                <div class="flex items-center mr-3 my-auto justify-end text-xl font-semibold text-csenBlue-950 dark:text-white">{{ (circolariInviateTransazionali['login_tecnico'] != null ? circolariInviateTransazionali['login_tecnico'].num_invii_effettuati : '-') }}</div>
                <div class="my-auto font-semibold">
                  <button
                    id="dettagli-circolari-inviate"
                    type="button"
                    class="bg-csenBlue-100 !text-csenBlue-500 dark:!text-white dark:bg-csenBlue-600 inline-flex justify-center content-center px-auto rounded-md group-hover:bg-csenBlue-500 group-hover:!text-white dark:hover:!brightness-125 transition w-9 h-9"
                    title="Visualizza e-mail"
                    >
                    <!-- @click="openRiepilogoInviiDialog(circolariInviateTransazionali['login_tecnico'])" -->
                    <EyeIcon class="my-auto"></EyeIcon>
                  </button>
                </div>
              </div>
            </div>

            <!-- Conferma Rinnovo - Pagamento automatico -->
            <div @click="openRiepilogoInviiDialog(circolariInviateTransazionali['conferma_rinnovo_auto'])" class="flex flex-col bg-csenBlue-50 group hover:bg-csenBlue-200 dark:bg-csenBlue-800 hover:dark:bg-csenBlue-700 rounded-md p-4 2xl:p-6 cursor-pointer transition h-full">
              <div class="flex justify-between content-evenly flex-grow">
                <div class="my-auto justify-start font-medium text-sm 2xl:text-base text-csenBlue-950 dark:text-csenBlue-200 ">Conferme Rinnovo - Pagamento automatico</div>
                <div class="flex items-center mr-3 my-auto justify-end text-xl font-semibold text-csenBlue-950 dark:text-white">{{ (circolariInviateTransazionali['conferma_rinnovo_auto'] != null ? circolariInviateTransazionali['conferma_rinnovo_auto'].num_invii_effettuati : '-') }}</div>
                <div class="my-auto font-semibold">
                  <button
                    id="dettagli-circolari-inviate"
                    type="button"
                    class="bg-csenBlue-100 !text-csenBlue-500 dark:!text-white dark:bg-csenBlue-600 inline-flex justify-center content-center px-auto rounded-md group-hover:bg-csenBlue-500 group-hover:!text-white dark:hover:!brightness-125 transition w-9 h-9"
                    title="Visualizza e-mail"
                  >
                  <!-- @click="openRiepilogoInviiDialog(circolariInviateTransazionali['conferma_rinnovo_auto'])" -->
                    <EyeIcon class="my-auto"></EyeIcon>
                  </button>
                </div>
              </div>
            </div>

            <!-- Conferma Rinnovo - Pagamento manuale -->
            <div @click="openRiepilogoInviiDialog(circolariInviateTransazionali['conferma_rinnovo_manuale'])" class="flex flex-col bg-csenBlue-50 group hover:bg-csenBlue-200 dark:bg-csenBlue-800 hover:dark:bg-csenBlue-700 rounded-md p-4 2xl:p-6 cursor-pointer transition h-full">
              <div class="flex justify-between content-evenly flex-grow">
                <div class="my-auto justify-start font-medium text-sm 2xl:text-base text-csenBlue-950 dark:text-csenBlue-200">Conferme Rinnovo - Pagamento manuale</div>
                <div class="flex items-center mr-3 my-auto justify-end text-xl font-semibold text-csenBlue-950 dark:text-white">{{ (circolariInviateTransazionali['conferma_rinnovo_manuale'] != null ? circolariInviateTransazionali['conferma_rinnovo_manuale'].num_invii_effettuati : '-') }}</div>
                <div class="my-auto font-semibold">
                  <button
                    id="dettagli-circolari-inviate"
                    type="button"
                    class="bg-csenBlue-100 !text-csenBlue-500 dark:!text-white dark:bg-csenBlue-600 inline-flex justify-center content-center px-auto rounded-md group-hover:bg-csenBlue-500 group-hover:!text-white dark:hover:!brightness-125 transition w-9 h-9"
                    title="Visualizza e-mail"
                  >
                  <!-- @click="openRiepilogoInviiDialog(circolariInviateTransazionali['conferma_rinnovo_manuale'])" -->
                    <EyeIcon class="my-auto"></EyeIcon>
                  </button>
                </div>
              </div>
            </div>

          </div>
  
         <div class="text-lg text-center font-bold text-normal-500 flex">
          <v-divider class="!my-auto"></v-divider>
          <h4 class="!my-auto px-3">Circolari massive</h4>
          <v-divider class="!my-auto"></v-divider>
        </div>
        <!-- circolariInviate.filter(filtroCircolari) -->
         <v-data-table 
            id="tabella-circolari-inviate" 
            class="tabella-csen mt-3" 
            :headers="headers"
            :items="circolariInviateMassive"
            :loading="isLoading"
            :search="search"
            :footer-props="{
              itemsPerPageText: 'Circolari per pagina'
            }"
            >
           
            <template v-slot:item.tipo="{ item }">
             <div class="font-semibold">
               <span>{{ conversioneTipoCircolare(item.tipo) }}</span>
             </div>
           </template>
            <template v-slot:item.data_invio="{ item }">
              <div>
  
                <!-- <span class="text-lg my-auto">📩</span> -->
  
                <v-tooltip bottom v-if="item.tipo == 'conferma_rinnovo_auto' || item.tipo == 'conferma_rinnovo_manuale' || item.tipo == 'login_tecnico'">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" style="text-decoration: underline; cursor: pointer;">
                      <span class="font-semibold my-auto dark:text-gray-300">{{ formattaDatatime(item.data_invio) }} </span>
                    </span>
                  </template>
                  <span>Corrisponde alla data di invio dell'ultima email</span>
                </v-tooltip>
                <span v-else>
                  <span class="font-semibold my-auto dark:text-gray-300">{{ formattaDatatime(item.data_invio) }} </span>
                </span>
  
              </div>
            </template>
  
           <template v-slot:item.num_invii_effettuati="{ item }">
              <div>
                <span>{{ item.num_invii_effettuati }}/{{ item.tot_destinatari }}</span>
              </div>
           </template>
   
            <template v-slot:item.nome_modello="{ item }">
              <span class="font-semibold text-csenBlue-950 hover:text-csenBlue-800 hover:underline cursor-pointer transition dark:text-gray-300"
                  @click="openModelloDialog(item)">
                {{ item.nome_modello }}
              </span>
            </template>
            
            <!-- AZIONI -->
            <template v-slot:item.azioni="{ item }">
              <div class="d-flex justify-end gap-1">
                <button
                  id="dettagli-circolari-inviate"
                  type="button"
                  @click="openRiepilogoInviiDialog(item)"
                  class="bg-csenBlue-100 !text-csenBlue-500 dark:!text-white dark:bg-csenBlue-600 inline-flex justify-center content-center px-auto rounded-md hover:bg-csenBlue-500 hover:!text-white dark:hover:!brightness-125 transition w-9 h-9"
                  title="Visualizza e-mail"
                >
                <EyeIcon class="my-auto"></EyeIcon>
              </button>
            </div>
          </template>
        </v-data-table>
   



        
         <!-- DIALOG Riepilogo Invii -->
         <template>
           <v-dialog v-model="riepilogoInviiDialog" width="1200px" persistent>
             <!-- @click:outside="closeRiepilogoInviiDialog" -->
             <v-card plain class="dark:!bg-csenBlue-950 dark:!border-0 dark:!ring-0 bg-white" v-if="riepilogoInvii">
               <v-card-title class="bg-csenBlue-900 dark:bg-csenBlue-800 font-bold text-2xl py-6 pl-8 text-white">
                 <span class="flex-grow">
                   <h3>
                     Report invio mail di tipo
                     <span class="text-csenBlue-200">{{ conversioneTipoCircolare(riepilogoInvii.tipo) }}</span>
                   </h3>
                 </span>
                  <v-btn class="!text-white" icon @click="closeRiepilogoInviiDialog">
                    <CloseIcon />
                  </v-btn>
               </v-card-title>
  
  
  
               <v-card-text class="!m-0 !p-0 dark:text-gray-300 bg-gray-200 dark:!bg-csenBlue-950">
                 
                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 py-8 mx-8 gap-6">
                
                
                    <!-- TOTALE DESTINATARI -->
                    <div class="flex items-center bg-white dark:bg-csenBlue-700 shadow-md shadow-gray-300 dark:shadow-none rounded-lg p-4 !w-full">
                            <div class="w-1/4 flex justify-center">
                              <div class="bg-indigo-100 text-indigo-600 dark:bg-white rounded-full p-3">
                                <MailContactIcon></MailContactIcon>
                              </div>
                            </div>
                            <div class="w-full lg:w-3/4 pl-4">
                              <div class="text-base font-semibold text-indigo-900 dark:text-csenBlue-200">Totale destinatari</div>
                              <div class="text-2xl font-bold text-indigo-500 dark:text-white">{{ riepilogoInvii.tot_destinatari }}</div>
                            </div>
                    </div>
  
                    <!-- INVII EFFETTUATI -->
                    <div class="flex items-center bg-white dark:bg-csenBlue-700 shadow-md shadow-gray-300 dark:shadow-none rounded-lg p-4 !w-full">
                        <div class="w-1/4 flex justify-center">
                          <div class="bg-csenBlue-100 !text-csenBlue-600  dark:bg-white rounded-full p-3">
                            <MailOutgoingIcon></MailOutgoingIcon>
                          </div>
                        </div>
                        <div class="w-full lg:w-3/4 pl-4">
                          <div class="text-base font-semibold text-csenBlue-800 dark:text-csenBlue-200">Invii effettuati</div>
                          <div class="text-2xl font-bold text-csenBlue-600 dark:text-white">{{ riepilogoInvii.num_invii_effettuati }}</div>
                        </div>
                    </div>
  
                    <!-- EMAIL APERTE -->
                    <div class="flex items-center bg-white dark:bg-csenBlue-700 shadow-md shadow-gray-300 dark:shadow-none rounded-lg p-4 !w-full">
                        <div class="w-1/4 flex justify-center">
                          <div class="bg-csenOrange-100 text-csenOrange-500 dark:bg-white rounded-full p-3">
                            <DraftIcon></DraftIcon> 
                          </div>
                        </div>
                        <div class="w-full lg:w-3/4 pl-4">
                          <div class="text-base font-semibold text-csenOrange-900 dark:text-csenBlue-200 ">Email aperte</div>
                          <div class="text-2xl font-bold text-csenOrange-600 dark:text-white">{{ riepilogoInvii.num_aperture }}</div>
                        </div>
                    </div>
  
                    <!-- EMAIL CLICCATE -->  
                    <div class="flex items-center bg-white dark:bg-csenBlue-700 shadow-md shadow-gray-300 dark:shadow-none rounded-lg p-4 !w-full">
                        <div class="w-1/4 flex justify-center">
                          <div class="bg-csenGreen-100 text-csenGreen-500 dark:bg-white rounded-full p-3">
                            <MailSuccessIcon></MailSuccessIcon>
                          </div>
                        </div>
                        <div class="w-full lg:w-3/4 pl-4">
                          <div class="text-base font-semibold text-csenGreen-900 dark:text-csenBlue-200">Email con link cliccato</div>
                          <div class="text-2xl font-bold text-csenGreen-600 dark:text-white">{{ riepilogoInvii.num_clicks }}</div>
                        </div>
                    </div>
  
                    <!-- INVII NON RIUSCITI -->
                    <div class="flex items-center bg-white dark:bg-csenBlue-700 shadow-md shadow-gray-300 dark:shadow-none rounded-lg p-4 !w-full">
                        <div class="w-1/4 flex justify-center">
                          <div class="bg-csenRed-100 text-csenRed-500 dark:bg-white rounded-full p-3">
                            <MailFailIcon></MailFailIcon>
                          </div>
                        </div>
                        <div class="w-full lg:w-3/4 pl-4">
                          <div class="text-base font-semibold text-csenRed-900 dark:text-csenBlue-200">Invii non riusciti</div>
                          <div class="text-2xl font-bold text-csenRed-600 dark:text-white">{{ riepilogoInvii.num_bounces }}</div>
                        </div>
                    </div>
  
                    <!-- EMAIL SPOSTATE IN SPAM-->
                    <div class="flex items-center bg-white dark:bg-csenBlue-700 shadow-md shadow-gray-300 dark:shadow-none rounded-lg p-4 !w-full">
                        <div class="w-1/4 flex justify-center">
                          <div class="bg-gray-100 text-gray-500 dark:bg-white rounded-full p-3">
                            <DeleteIcon class="!h-8 !w-8"></DeleteIcon>
                          </div>
                        </div>
                        <div class="w-full lg:w-3/4 pl-4">
                          <div class="text-base font-semibold text-gray-900 dark:text-csenBlue-200">Email spostate in SPAM</div>
                          <div class="text-2xl font-bold text-gray-600 dark:text-white">{{ riepilogoInvii.num_spostate_in_spam }}</div>
                        </div>
                    </div>
  
                </div> 
                
               </v-card-text>
  
               <v-card-text>
                <!-- La tabella viene mostrata solo per i tipi che effettuano invii singoli -->
                <div class="my-3">

                  <v-row>
                    <!--<v-spacer></v-spacer>   Spazio per allineare a destra -->
                    <v-col cols="9" md="9">
                      <v-text-field
                        v-model="searchReportInvio"
                        label="Cerca..."
                        append-icon="mdi-magnify"
                        outlined
                        hide-details
                        clearable
                        class="!px-4 !mt-3 !mb-1"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="3" md="3">
                      <v-select
                        v-model="filtroStatoReportInvio"
                        :items="[
                          { text: 'Tutti', value: 'tutti' },
                          { text: 'Cliccata', value: 'click' },
                          { text: 'Inviata', value: 'inviata' },
                          { text: 'Aperta', value: 'aperta' },
                          { text: 'Invio non riuscito', value: 'bounce' },
                          { text: 'Spostata in Spam', value: 'spam' }
                        ]"
                        item-text="text"
                        item-value="value"
                        label="Stato"
                        outlined
                        class="!px-4 !mt-3 !mb-1"
                        hide-details
                      ></v-select>
                    </v-col>
                    <v-divider></v-divider>
                  </v-row>

                  <!-- Ricerca non più gestita dalla tabella -->
                  <!-- :search="searchReportInvio" -->
                  <v-data-table class="mt-3"
                                :headers="getHeaderInviiSingoli(riepilogoInvii.tipo)"
                                :items="singoliInvii"
                                :loading="isLoadingSingoliInvii"
                                :options.sync="tabellaSingoliInviiOptions"
					                      :server-items-length="numTotaleSingoliInvii"
                                :footer-props="{
                                  itemsPerPageOptions: [15, 50, 100],
                                  itemsPerPageText: $vuetify.breakpoint.xs ? '' : 'Email per pagina',
                                  showCurrentPage: true,
                                  showFirstLastPage: false
                                }"
                  >
                   
                    <template v-slot:item.tipo="{ item }">
                     <span class="!font-semibold"> {{ item.tipo }} </span>
                    </template>
                   
                    <template v-slot:item.data_invio="{ item }">
                      <div>
                        <span class="text-lg my-auto">📩</span>
                        <span class="font-semibold my-auto dark:text-gray-300">{{ formattaDatatime(item.data_invio) }} </span>
                      </div>
                    </template>
  
                    <template v-slot:item.nome_modello="{ item }">
                      <span class="font-semibold text-csenBlue-950 hover:text-csenBlue-800 hover:underline cursor-pointer transition dark:text-gray-300"
                          @click="openModelloDialog(item)">
                        {{ item.nome_modello }}
                      </span>
                    </template>
  
                    <template v-slot:item.stato_email="{ item }">
                        <div
                          v-if="item.stato_email === 'click'"
                          class="bg-csenGreen-100 text-csenGreen-500 dark:text-white dark:bg-csenGreen-500 inline-block rounded-full px-3 py-1"
                        >
                          Cliccata
                        </div>
  
                        <div
                          v-else-if="item.stato_email === 'inviata'"
                          class="bg-csenBlue-100 text-csenBlue-600 dark:text-white dark:bg-csenBlue-500 inline-block rounded-full px-3 py-1"
                        >
                          Inviata
                        </div>
  
                        <div
                          v-else-if="item.stato_email === 'aperta'"
                          class="bg-csenOrange-100 text-csenOrange-600 dark:text-white dark:bg-csenOrange-500 inline-block rounded-full px-3 py-1"
                        >
                          Aperta
                        </div>
  
                        <div
                          v-else-if="item.stato_email === 'bounce'"
                          class="bg-csenRed-100 text-csenRed-600 dark:text-white dark:bg-csenRed-500 inline-block rounded-full px-3 py-1"
                        >
                          <span>Invio non riuscito</span>
                          <v-icon v-if="riepilogoInvii.tipo && (riepilogoInvii.tipo.startsWith('reminder_') || riepilogoInvii.tipo.startsWith('sollecito_') || riepilogoInvii.tipo == 'invio_massivo')"
                              color="blue" @click.stop="apriModaleReinvio(item.id, item.email_destinatario)" class="cursor-pointer">
                            mdi-refresh
                          </v-icon>
                        </div>
  
                        <div
                          v-else-if="item.stato_email === 'spam'"
                          class="bg-gray-100 text-gray-600 dark:text-white dark:bg-gray-500 inline-block rounded-full px-3 py-1"
                        >
                          Spostata in Spam
                        </div>
                      </template>
  
  
                  </v-data-table>
                </div>
               </v-card-text>
  
               <v-card-actions class="p-4 justify-end bg-gray-200 dark:bg-csenBlue-800 sticky bottom-0 z-40">
                 <v-btn class="!bg-csenBlue-900 !text-white !tracking-wider !py-5 !px-5 dark:bg-gray-700" text @click="closeRiepilogoInviiDialog()">Chiudi</v-btn>
               </v-card-actions>
             </v-card>
           </v-dialog>
         </template>
  
          <template>
            <v-dialog v-model="modelloEmailDialog" width="850px" persistent>
              <!-- @click:outside="closeModelloDialog" -->
              <v-card plain class="dark:!bg-csenBlue-800">
                <v-card-title class="font-bold text-2xl py-6 pl-8 dark:text-white">
                  <span class="flex-grow">
                    <h3>
                      Anteprima dell'email inviata
                    </h3>
                  </span>
                  <v-btn class="!text-gray-900 dark:!text-csenBlue-200" icon @click="closeModelloDialog">
                    <CloseIcon />
                  </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="!m-0 !p-0 dark:text-gray-300">
                  <!-- Preview Modello Email -->
                  <ModelloEmailComponent :dati="datiModelloEmailAperto" :only-view="true"></ModelloEmailComponent>
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>

          <!-- Reinvio singola email se ha fatto bounce (con cambio email del tecnico) -->
          <template>
            <!-- aaaa -->
            <v-dialog v-model="isModaleReinvioOpen" width="600px" persistent>
              <v-card plain class="dark:!bg-csenBlue-800">
                <v-card-title class="font-bold text-2xl pt-6 pb-3 pl-8 dark:text-white">
                  <span class="flex-grow">
                    <h3>Effettua reinvio email</h3>
                    <p class="text--secondary body-2 mb-4">Verrà creata una nuova circolare con un unico destinatario</p>
                  </span>
                  <v-btn class="!text-gray-900 dark:!text-csenBlue-200" icon @click="chiudiModaleReinvio">
                    <CloseIcon />
                  </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="!m-0 !p-0 dark:text-gray-300">
                  <!-- hide-details -->
                  <v-form v-model="reinvioBouncedForm" ref="reinvioBouncedForm">
                    <br/>
                    <b class="!px-4 !mb-3">Modifica l'email del tecnico per effettuare il reinvio:</b>
                    <v-text-field
                      v-model="reinvioEmailAttuale"
                      outlined
                      class="!px-4 !mt-3 !mb-6"
                      placeholder="Nuova email tecnico"
                      clear-icon="mdi-close-circle-outline"
                      :rules="[rules.required, rules.email]"
                    ></v-text-field>
                  </v-form>
                  
                </v-card-text>
                <v-card-actions class="p-4 justify-end bg-gray-200 dark:bg-csenBlue-800 sticky bottom-0 z-40">
                  <v-btn class="!bg-gray-400/30 dark:!bg-transparent !tracking-wider !py-5 !px-4" text @click="chiudiModaleReinvio">
                    Annulla
                  </v-btn>
                  <v-btn class="!bg-csenBlue-900 !text-white !tracking-wider !py-5 !px-5 dark:bg-gray-700" text @click="reinviaEmail()">
                    Reinvia email
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
  

        <!-- LOGOUT -->
        <div class="block sm:flex gap-2 !justify-start border-t border-t-gray-300 dark:border-t-csenBlue-300 pt-4 mt-3">
          <template>
          <v-btn v-if="loggedAs && loggedAs.ruolo && loggedAs.ruolo.length > 0" class=" !block !mb-2 sm:!inline sm:!mb-0 !tracking-normal !bg-slate-200 !text-slate-600 dark:!text-white dark:!bg-csenBlue-800" @click="logout">
            <v-icon left>mdi-logout</v-icon>
            Logout
          </v-btn>
          </template>
        </div>

		  <!-- TO TOP -->
      <div 
               class="flex fixed justify-end items-end bottom-6 md:bottom-5 right-6 md:right-5 bg-csenBlue-800 rounded-full px-2 py-2 !z-[60] cursor-pointer hover:bg-csenOrange-500 transition" 
               @click="scrollToTop"
			   title="Torna in cima"
            ><div><ChevronUpIcon></ChevronUpIcon></div>
            </div>
         <!-- FOOTER -->
       <div>
         <FooterComponent></FooterComponent>
       </div>
       <!-- FINE FOOTER -->
    </div>
   
       <v-tour name="myTourCircolariInviate" :steps="tourSteps" :options="tourOptions" :callbacks="tourCallbacks"></v-tour>
  
       <!-- Overlay per bloccare i click durante il tour -->
       <div v-if="tourAvviato" class="tour-overlay"></div>
  
     </div>
   </template>
   
   <script>
      import MenuTecnici from '../components/MenuTecnici.vue';
      import DeleteIcon from '../components/icons/DeleteIcon.vue';
      import DraftIcon from '../components/icons/DraftIcon.vue';
      import EyeIcon from '../components/icons/EyeIcon.vue';
      import MailFailIcon from '../components/icons/MailFailIcon.vue';
      import MailSuccessIcon from '../components/icons/MailSuccessIcon.vue';
      import SendMailIcon from '../components/icons/SendMailIcon.vue';
      import MailOutgoingIcon from '../components/icons/MailOutgoingIcon.vue';
      import HistoryIcon from '../components/icons/HistoryIcon.vue';
      import MailContactIcon from '../components/icons/MailContactIcon.vue';
      import mixin from '../mixin';
      import store from '../store';
  
   
    export default {
      components: {
        MenuTecnici, EyeIcon, SendMailIcon, HistoryIcon, MailSuccessIcon, MailFailIcon, EyeIcon, DraftIcon, MailOutgoingIcon, MailContactIcon
      },
     
      mixins: [mixin],
      data() {
       return {
          isLoading: false,
          riepilogoInviiDialog: false,
          search: null,
          circolariInviateMassive: [],
          headers: [
            { text: 'Tipo di circolare', value: 'tipo' },
            { text: 'Data invio', value: 'data_invio' },
            { text: 'Destinatari', value: 'num_invii_effettuati' },
            { text: 'Nome modello', value: 'nome_modello' },
            { text: 'Oggetto', value: 'oggetto' },
            { text: 'Azioni', value: 'azioni', sortable: false, class: 'text-end' },
          ],

          isLoadingTransazionali: false,
          circolariInviateTransazionali: {
            'login_tecnico': null,
            'conferma_rinnovo_auto': null,
            'conferma_rinnovo_manuale': null
          },

          datiModelloEmailAperto: {},
          modelloEmailDialog: false,
    
          riepilogoInvii: null,
  
          // Per la gestiona asincrona della tabella:
          tabellaSingoliInviiOptions: {
            page: 1,
            itemsPerPage: 15,
            sortBy: [],
            sortDesc: [],
          },

          numTotaleSingoliInvii: 0,

          singoliInvii: [],
          isLoadingSingoliInvii: false,
  
          tourAvviato: false,
          tourCallbacks: {
            onFinish: this.fineTour,
            onSkip: this.fineTour,
            onStop: this.fineTour,
          },
          tourSteps: [
            {
              target: '#menu-circolari-inviate-tab',
              content: `
                Benvenuto nella sezione delle “Circolari Inviate” dove potrai monitorare le perfomance delle tue circolari!
              `
            },
            {
              target: '#tabella-circolari-inviate',
              content: `
                In questa tabella trovi l’elenco delle circolari inviate con i relativi dettagli.
              `
            },
            {
              target: '#dettagli-circolari-inviate',
              content: `
                Clicca su questa icona per vedere il Report di invio di ogni circolare: vedrai quante persone l'hanno ricevuta, aperta e altre statistiche utili!
              `
            },
            {
              target: '#mostra-guida',
              content: `
                Grazie per aver seguito la Guida!<br/><br/>
                Ricorda che puoi riaprirla in ogni momento cliccando qui su "Mostra Guida".<br/><br/>
                Saluti sportivi!
              `
            }
          ],

          searchReportInvio: null,
          filtroStatoReportInvio: 'tutti',

          reinvioBouncedForm: null,
          isModaleReinvioOpen: null,
          reinvioId: null, // Impostata quando è necessario effettuare un reinvio
          reinvioEmailAttuale: null,

          is_storico_richiesto: false,
       };
      },
      created() {
        this.getCircolariInviateMassive();
        this.getCircolariInviateTransazionali();
      },
      mounted(){
        if(!this.isGuidaCompleta('is_guida_email_inviate_completa')){
          this.tourAvviato = true;
          this.$tours['myTourCircolariInviate'].start();
          this.setGuidaCompleta('is_guida_email_inviate_completa');
        }
      },
      watch: {
        tabellaSingoliInviiOptions: {
          handler(newOptions, oldOptions) {
            console.log(this.riepilogoInvii);
            this.getRiepilogoSingoliInvii(this.riepilogoInvii.tipo, this.riepilogoInvii.data_invio)
          },
          deep: true, // Necessario per osservare le modifiche agli oggetti annidati
        },

        searchReportInvio: {
          handler(newOptions, oldOptions) {
            this.refreshTabellaSingoliInviiOptions()
            this.getRiepilogoSingoliInvii(this.riepilogoInvii.tipo, this.riepilogoInvii.data_invio)
          }
        },

        filtroStatoReportInvio: {
          handler(newOptions, oldOptions) {
            this.refreshTabellaSingoliInviiOptions()
            this.getRiepilogoSingoliInvii(this.riepilogoInvii.tipo, this.riepilogoInvii.data_invio)
          }
        },

        is_storico_richiesto: {
          handler(newOptions, oldOptions) {
            this.getCircolariInviateMassive();
            this.getCircolariInviateTransazionali();
          }
        },

      },
      methods: {
        refreshTabellaSingoliInviiOptions(){
          this.tabellaSingoliInviiOptions = { // Ripristino
            page: 1,
            itemsPerPage: 15,
            sortBy: [],
            sortDesc: [],
          }
        },

        avviaTour(){
          this.tourAvviato = true;
          this.$tours['myTourCircolariInviate'].start();
        },
        fineTour(){
          this.tourAvviato = false;
        },
        openModelloDialog(dati) {
          console.log(dati)
          this.datiModelloEmailAperto = {
            id: null,
            nome: dati.nome_modello,
            oggetto: dati.oggetto,
            corpo: dati.corpo,
            anteprima: dati.anteprima,
            rispondi_a: dati.rispondi_a
          }
  
          this.modelloEmailDialog = true;
        },
        closeModelloDialog() {
            this.datiModelloEmailAperto = null;
            this.modelloEmailDialog = false;
        },
        openRiepilogoInviiDialog(dati) {
          this.refreshTabellaSingoliInviiOptions();

          this.riepilogoInvii = dati;
          this.getRiepilogoSingoliInvii(dati.tipo, dati.data_invio);
    
          this.riepilogoInviiDialog = true;
        },
        closeRiepilogoInviiDialog() {
          this.searchReportInvio = null;
          this.filtroStatoReportInvio = 'tutti';
          this.riepilogoInvii = null;
          this.riepilogoInviiDialog = false;
        },
        getCircolariInviateMassive() {
          this.isLoading = true;
          axios
            .get(`circolari_inviate_massive?is_storico_richiesto=${this.is_storico_richiesto}`)
            .then((res) => {
              this.circolariInviateMassive = res.data;
            })
            .finally(() => {
              this.isLoading = false;
            });
        },
        getCircolariInviateTransazionali() {
            this.isLoadingTransazionali = true;
            axios
              .get(`circolari_inviate_transazionali?is_storico_richiesto=${this.is_storico_richiesto}`)
              .then((res) => {

                // I tipi dovrebbero essere 3 (tranne all'inizio in cui non c'è ad esempio alcuna conferma di rinnovo)
                this.circolariInviateTransazionali = {}; // Resetto prima il numero di invii effettuati
                res.data.forEach(el => {
                  this.circolariInviateTransazionali[el.tipo] = JSON.parse(JSON.stringify(el));
                })
              })
              .finally(() => {
                this.isLoadingTransazionali = false;
              });
        },
        getRiepilogoSingoliInvii(tipo, dataInvio){
            this.isLoadingSingoliInvii = true;
            this.singoliInvii = [];
            axios
              .post(`riepilogo_singoli_invii?is_storico_richiesto=${this.is_storico_richiesto}`, {
                tipo: tipo, 
                dataInvio: dataInvio,

                pagina: this.tabellaSingoliInviiOptions.page,
                itemPerPagina: this.tabellaSingoliInviiOptions.itemsPerPage,
                // options: this.tabellaSingoliInviiOptions,
                search: this.searchReportInvio,
                statoSelezionato: this.filtroStatoReportInvio
              })
              .then((res) => {
                this.singoliInvii = res.data.data;
                this.numTotaleSingoliInvii = res.data.total
              })
              .finally(() => {
                this.isLoadingSingoliInvii = false;
              });
        },
        getHeaderInviiSingoli(tipo){
          if(tipo == 'login_tecnico'){
            return [
              { text: 'Data invio', value: 'data_invio', sortable: false },
              { text: 'Tecnico', value: 'nome_completo_tecnico', sortable: false },
              { text: 'Email', value: 'email_destinatario', sortable: false },
              { text: 'Stato email', value: 'stato_email', sortable: false },
            ]
          } else /*if (tipo.startsWith('conferma_rinnovo_'))*/ {
            return [
              { text: 'Data invio', value: 'data_invio', sortable: false },
              { text: 'Tecnico', value: 'nome_completo_tecnico', sortable: false },
              { text: 'Email', value: 'email_destinatario', sortable: false },
              { text: 'Modello', value: 'nome_modello', sortable: false },
              { text: 'Stato email', value: 'stato_email', sortable: false },
            ]
          }
        },
        apriModaleReinvio(reinvioId, emailAttuale){
          this.reinvioId = reinvioId;
          this.reinvioEmailAttuale = emailAttuale;
          this.isModaleReinvioOpen = true;
        },
        chiudiModaleReinvio(){
          this.reinvioId = null;
          this.reinvioEmailAttuale = null;
          this.isModaleReinvioOpen = false;
        },
        reinviaEmail(){ // Per le email che hanno fatto bounce
          if(!this.$refs['reinvioBouncedForm'].validate())
            return
          
          store.commit('mostraDialogConferma',
            {
              titolo: 'Invia email',
              testo:`Sicuro di voler inviare l'email?`,
              onConferma:()=>{
                axios
                  .post(`reinvia_circolare_bounced`, {email_inviata_id: this.reinvioId, nuova_email_tecnico: this.reinvioEmailAttuale })
                  .then((res) => {
                    this.chiudiModaleReinvio();
                    this.closeRiepilogoInviiDialog()
                    this.getCircolariInviateMassive();
                    this.getCircolariInviateTransazionali();

                    store.commit('mostraSnack', {messaggio: 'La nuova circolare sarà disponibile a breve', tipo: 'success'})
                  })
                  .finally(() => {});
                store.commit('nascondiDialogConferma')
              },
              onAnnulla:()=>{
                store.commit('nascondiDialogConferma')
              }
            }
          )
        }
      },
      computed: {
        // singoliInviiComputed(){
        //   if(this.filtroStatoReportInvio == null || this.filtroStatoReportInvio == 'tutti')
        //     return this.singoliInvii;
          
        //   return this.singoliInvii.filter(el => {
        //     if(el.stato_email == this.filtroStatoReportInvio) return true;
        //     return false;
        //   })
        // }
      }
    };
  </script>
   
  <style lang="scss" scoped>
  
   .tabella-csen {
      background-color: #fff; 
      ::v-deep .v-data-table__wrapper th {
         color: #27316e !important;
         font-size:15px !important;
         background-color: #eef5ff;
         padding: 1rem;
      }
   };
  
   .dark {
      ::v-deep .v-data-table__wrapper th {
         color: #c7dcfe !important;
         font-size:15px !important;
         padding: 1rem;
      }
   };
  
  </style>
   